import React, { Component } from 'react';
import documentData from '../../constants/documentType.json'
import Document from '../shared/document/Document';
import PageInfo from '../shared/pageInfo/PageInfo';

class IntroductionPage extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        const introIcon = process.env.BASE_URL + "images/app/info.png";
        var introductionData = documentData.filter(document => document.folderName == "Introduction")[0];
        var documents = introductionData.files.map(file => {
            return <Document DocName={file.name} key={file.id} path={file.path} type={file.downloadType} />
        })
        return (
            <div className="mainBoxContent">
                <PageInfo pageTitle={introductionData.title} pageContent={introductionData.content} imgIcon={introIcon} />
                <div className="docContainer">
                    {documents}
                </div>
            </div >
        )
    }
}

export default IntroductionPage;